<template lang="pug">
.container.grid-lg
  form.columns.align-center.my-2(@submit.prevent="listar")
    .form-group.column.col-2.col-md-4.col-sm-12
      small Pagamento inicial
      datepicker(
        v-model="q.pago_em_gteq",
        placeholder="inicial",
        input-class="form-input input-sm"
      )
    .form-group.column.col-2.col-md-4.col-sm-12
      small Pagamento final
      datepicker(
        v-model="q.pago_em_lteq",
        placeholder="final",
        input-class="form-input input-sm",
        full-day
      )
    .form-group.column.col-2.col-md-4.col-sm-12
      small Com documento
      select.form-select.select-sm(v-model="q.doc_id_gt")
        option(:value="0") Com documento
        option(:value="null") Todos
    .form-group.column.col-2.col-md-4.col-sm-12
      small {{ "pagamento.doc" | tModel }}
      doc-picker(v-model="q.doc_id_eq", sm)
    .form-group.column.col-2.col-md-4.col-sm-12
      small {{ "pagamento.cadastro" | tModel }}
      cadastro-picker(v-model="q.cadastro_id_eq", sm)
    .form-group.column.col-auto.no-print
      button.btn.btn-link.tooltip.tooltip-bottom(
        type="submit",
        data-tooltip="Filtrar",
        :disabled="loading"
      )
        i.fa.fa-search.fa-2x
  load-manager(:status="status")
    div(v-if="list.length > 0")
      table.table.table-striped.table-hover.table-sm
        thead
          tr
            th {{ "pagamento.debito_tipo" | tModel }}
            th {{ "pagamento.parcela" | tModel }}
            th {{ "pagamento.pago_em" | tModel }}
            th Valor pago
            th {{ "pagamento.cadastro" | tModel }}
            th {{ "pagamento.doc" | tModel }}
            th.no-print
        tbody.text-small
          tr(v-for="pagamento in list", :key="pagamento.id")
            td.text-small(v-if="pagamento.debito_tipo") {{ pagamento.debito_tipo.id }}: {{ pagamento.debito_tipo.descricao }}
            td(v-else)
            td {{ pagamento.parcela }}
            td {{ pagamento.pago_em | date("DD/MM/YYYY") }}
            td {{ pagamento.valor_documento | currency }}
            td(v-if="pagamento.cadastro") {{ pagamento.cadastro.numero }}
            td(v-else) -
            td(v-if="pagamento.doc") {{ pagamento.doc.numero }}/{{ pagamento.doc.ano }}: {{ pagamento.doc.valor_total | currency }}
            td(v-else) -
            td.no-print
              router-link(
                :to="{ name: 'app.osm.consultas.pagamentos.show', params: { id: pagamento.id } }"
              )
                btn-icon(name="show")
    .empty.mt-2(v-else)
      .empty-icon
        i.icon.icon-search
      p.empty-title.h5 Nenhum Registro encontrado
    .my-2.text-right(v-if="pages > 1")
      btn-paginate(
        :page="page",
        :pages="pages",
        :count="count",
        @go-page="goPage",
        @prev-page="prevPage",
        @next-page="nextPage"
      )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"

export default {
  vuex: { pagamentos: vuexDefaultMapping },
  data() {
    return { q: { pago_em_order_by: "desc", doc_id_gt: 0 } }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
